// Modals
const Modal = require(MODULES_PATH + '/modal');
const modalInstances = {};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.therapist-modal').forEach((modalElement) => {
    const modalId = modalElement.id;

    // Generate unique class names for open and close buttons based on modal ID
    const openButtonClass = `${modalId}-open-button`;
    const closeButtonClass = `${modalId}-close-button`;

    modalInstances[modalId] = new Modal({
      modalId: modalId,
      openButtonClass: openButtonClass, // Use the dynamically generated open button class
      closeButtonClass: closeButtonClass, // Use the dynamically generated close button class
      scrollTracker: false,
      scrollAdjust: false,
      center: false,
      closeOnWrapperClick: false,
      resetOnClose: true,
      keepHidden: false,
      backdrop: {
        color: '#e0dad8',
        opacity: 0.16,
        effect: false,
        blur: 3.14,
      },
    });

    // Bind event listeners for modal state (opened or closed)
    bindModalEvents(modalId);
  });

  document.querySelectorAll('.contact-form-modal').forEach((modalElement) => {
    const modalId = modalElement.id;

    // Generate unique class names for open and close buttons based on modal ID
    const openButtonClass = `${modalId}-open-button`;
    const closeButtonClass = `${modalId}-close-button`;

    modalInstances[modalId] = new Modal({
      modalId: modalId,
      openButtonClass: openButtonClass, // Use the dynamically generated open button class
      closeButtonClass: closeButtonClass, // Use the dynamically generated close button class
      scrollTracker: false,
      scrollAdjust: false,
      center: false,
      closeOnWrapperClick: false,
      resetOnClose: true,
      keepHidden: false,
      backdrop: {
        color: '#e0dad8',
        opacity: 0.16,
        effect: false,
        blur: 3.14,
      },
    });

    // Bind event listeners for modal state (opened or closed)
    bindModalEvents(modalId);
  });

  document
    .querySelectorAll('.billing-help-form-modal')
    .forEach((modalElement) => {
      const modalId = modalElement.id;

      // Generate unique class names for open and close buttons based on modal ID
      const openButtonClass = `${modalId}-open-button`;
      const closeButtonClass = `${modalId}-close-button`;

      modalInstances[modalId] = new Modal({
        modalId: modalId,
        openButtonClass: openButtonClass, // Use the dynamically generated open button class
        closeButtonClass: closeButtonClass, // Use the dynamically generated close button class
        scrollTracker: false,
        scrollAdjust: false,
        center: false,
        closeOnWrapperClick: false,
        resetOnClose: true,
        keepHidden: false,
        backdrop: {
          color: '#e0dad8',
          opacity: 0.16,
          effect: false,
          blur: 3.14,
        },
      });

      // Bind event listeners for modal state (opened or closed)
      bindModalEvents(modalId);
    });
});

function bindModalEvents(modalId) {
  document.addEventListener(`${modalId}openmodal`, function () {
    // Updating ARIA attributes when modal is opening
    const targetModal = document.querySelector(`[data-modal-id="${modalId}"]`);
    targetModal?.setAttribute('aria-expanded', 'true');
  });

  document.addEventListener(`${modalId}closemodal`, function () {
    // Updating ARIA attributes when modal is closing
    const targetModal = document.querySelector(`[data-modal-id="${modalId}"]`);
    targetModal?.setAttribute('aria-expanded', 'false');
  });
}
